var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"common-img",style:({ 'height': _vm.height }),attrs:{"alt":_vm.alt,"src":_vm.src,"xsrc":"https://resources.interface003.com/web20/img/default/article.png"},on:{"error":function($event){_vm.src = _vm.defaultImg;}}})}
var staticRenderFns = []

export { render, staticRenderFns }